import { httpBlobWithMeta, httpJson } from "./client";

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

function filenameFromDisposition(disposition, fallback) {
  const cd = String(disposition || "").trim();
  if (!cd) return fallback;
  const utf = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf && utf[1]) {
    try {
      return decodeURIComponent(String(utf[1]).replace(/^"|"$/g, "")) || fallback;
    } catch (_e) {
      return String(utf[1]).replace(/^"|"$/g, "") || fallback;
    }
  }
  const simple = cd.match(/filename\s*=\s*("?)([^";]+)\1/i);
  if (simple && simple[2]) return String(simple[2]).trim() || fallback;
  return fallback;
}

export async function listInvoices({ jobId = "", limit = 200, offset = 0 } = {}) {
  const p = new URLSearchParams();
  if (String(jobId || "").trim()) p.set("job_id", String(jobId).trim());
  p.set("limit", String(limit));
  p.set("offset", String(offset));
  return await httpJson(`/invoices?${p.toString()}`, { method: "GET" });
}

export async function createInvoice(payload) {
  return await httpJson("/invoices", { method: "POST", body: payload });
}

export async function getInvoice(invoiceId) {
  return await httpJson(`/invoices/${encodeURIComponent(String(invoiceId || "").trim())}`, { method: "GET" });
}

export async function updateInvoice(invoiceId, payload) {
  return await httpJson(`/invoices/${encodeURIComponent(String(invoiceId || "").trim())}`, { method: "PUT", body: payload });
}



export async function getInvoiceJobDefaults(jobId) {
  const id = String(jobId || "").trim();
  if (!id) throw new Error("jobId is required");
  const p = new URLSearchParams({ job_id: id });
  return await httpJson(`/invoices/job-defaults?${p.toString()}`, { method: "GET" });
}
export async function getInvoiceJobFieldOptions(jobId) {
  const id = String(jobId || "").trim();
  const p = new URLSearchParams();
  if (id) p.set("job_id", id);
  return await httpJson(`/invoices/job-field-options?${p.toString()}`, { method: "GET" });
}

export async function getInvoiceLogoDefault() {
  return await httpJson("/invoices/logo-default", { method: "GET" });
}

export async function downloadInvoiceContractorPdf(invoiceId) {
  const id = String(invoiceId || "").trim();
  const { blob, headers } = await httpBlobWithMeta(`/invoices/${encodeURIComponent(id)}/export/contractor.pdf`, { method: "GET" });
  const filename = filenameFromDisposition(headers?.get("content-disposition"), `invoice_${id}_contractor.pdf`);
  downloadBlob(blob, filename);
}

export async function downloadInvoiceAdjusterCsv(invoiceId) {
  const id = String(invoiceId || "").trim();
  const { blob, headers } = await httpBlobWithMeta(`/invoices/${encodeURIComponent(id)}/export/adjuster.csv`, { method: "GET" });
  const filename = filenameFromDisposition(headers?.get("content-disposition"), `invoice_${id}_adjuster.csv`);
  downloadBlob(blob, filename);
}




